import { Link } from "react-router-dom";
import { useLang } from "@/lib/i18n";
import { getPages } from "@/lib/servicePages";
import { SocialLinks } from "@/components/SocialLinks";
import { scrollToId } from "@/lib/api";

export const Footer = () => {
  const { t, c, lang } = useLang();
  const tf = t.footer;
  return (
    <footer data-testid="site-footer" className="border-t border-line bg-coal/60">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-20 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <img src="/logo.png" alt={tf.logoAlt} className="h-12 w-auto mb-5" />
          <p data-testid="footer-slogan" className="font-serif text-2xl text-mist leading-tight mb-1">{tf.slogan}</p>
          <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-gold mb-6">{tf.sloganEn}</p>
          <p className="text-dim text-sm leading-relaxed max-w-sm">{tf.text}</p>
          <SocialLinks prefix="footer" className="mt-8" />
        </div>
        <div className="md:col-span-3">
          <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-dim mb-5">{tf.services}</p>
          <ul className="flex flex-col gap-3">
            {getPages(lang).map((s) => (
              <li key={s.id}>
                <Link to={`/uslugi/${s.slug}`} data-testid={`footer-service-${s.id}`} className="text-dim text-sm hover:text-gold transition-colors duration-300">
                  {s.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-2">
          <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-dim mb-5">{tf.nav}</p>
          <ul className="flex flex-col gap-3">
            {c.NAV_LINKS.map((l) => (
              <li key={l.href}>
                <button data-testid={`footer-${l.testid}`} onClick={() => scrollToId(l.href)} className="text-dim text-sm hover:text-gold transition-colors duration-300">
                  {l.label}
                </button>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-3">
          <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-dim mb-5">{tf.contacts}</p>
          <ul className="flex flex-col gap-3 text-sm text-dim">
            <li data-testid="footer-address">{c.CONTACTS.address}</li>
            <li data-testid="footer-phone">
              <a href={`tel:${c.CONTACTS.phone.replace(/\s/g, "")}`} className="hover:text-gold transition-colors duration-300">{c.CONTACTS.phone}</a>
            </li>
            <li data-testid="footer-email">
              <a href={`mailto:${c.CONTACTS.email}`} className="hover:text-gold transition-colors duration-300">{c.CONTACTS.email}</a>
            </li>
            <li data-testid="footer-hours">{c.CONTACTS.hours}</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-line">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-5 flex flex-wrap gap-x-5 gap-y-2" data-testid="footer-keywords">
          {c.SEO_KEYWORDS.map((k) => (
            <span key={k} className="font-mono text-[11px] uppercase tracking-[0.2em] text-dim/60">{k}</span>
          ))}
        </div>
      </div>
      <div className="border-t border-line">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-dim/60 text-xs">{tf.rights}</p>
          <Link to="/admin/login" data-testid="footer-admin-link" className="text-dim/60 text-xs hover:text-gold transition-colors duration-300">
            {tf.admin}
          </Link>
        </div>
      </div>
    </footer>
  );
};
